export const download = (data, fileName, successCB) => {
  const url = window.URL.createObjectURL(new Blob([data], {type:'application/vnd.ms-excel'}));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  return successCB(data);
}